import styled from '../../theme/styled-with-theme';
import { Box } from '../Box';
import { mediaQueries } from '../../styles/media-queries';
import { Flexbox } from '../Flexbox';
import { pxToRem } from '../../styles/utils';

export const Wrapper = styled(Flexbox)`
  flex-direction: column-reverse;
  padding: 0 ${({ theme }) => theme.spacing.s};
  margin: 0 auto;

  ${mediaQueries.tablet} {
    max-width: ${pxToRem(880)};
    flex-wrap: nowrap;
    flex-direction: row;
  }
`;

export const TextWrapper = styled(Box)<{ textAlign: string }>`
  width: 100%;

  ${mediaQueries.tablet} {
    width: auto;
    margin: auto;
    padding-top: 40px;
    padding-bottom: 40px;
    text-align: ${({ textAlign }) => textAlign};
  }
`;

export const ListItem = styled('li')`
  padding-left: 10px;
  p {
    font-size: ${({ theme }) => theme.fontSize.p_0};
    font-weight: ${({ theme }) => theme.fontWeight.p};
    margin-bottom: 15px;
  }

  ${mediaQueries.tablet} {
    p {
      font-size: ${({ theme }) => theme.fontSize.h3_tablet};
      font-weight: ${({ theme }) => theme.fontSize.h3_tablet};
      margin-bottom: 25px;
    }
  }
`;
